
import ReportSubscribed from "@/components/marketAnalysis/ReportSubscribed";
import FormatterService from '@/service/FormatterService';

export default {
    name: 'MarketSummaryCard',

    components: { 
        ReportSubscribed,
    },

    props: {
        marketSummaryContent: {
            type: String,
            default: ''
        },
        createdAt: {
            type: String,
            default: ''
        },
        isReportSubscribed: {
            type: Boolean,
            default: false,
        },
    },

    emits: ['open-subscription-dialog'],

    computed: {
        displayedCreatedAt() {
            if (!this.createdAt) {
                return '';
            }

            const dateOpt = {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                hour12: false
            };
            const dateLocale = {
                'en': 'en-CA',
                'de': 'de-DE',
                'fr': 'fr-FR',
                'es': 'es-ES',
            };
            const locale = this.$getCurrentLocale();

            return this.format.date({ locale: dateLocale[locale], date: this.createdAt }, dateOpt);
        }
    },

    created() {
        this.format = new FormatterService();
    }
}
